import { j as C } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: t = 20,
  height: r = 20,
  viewBox: s = "0 0 20 20",
  fill: o = "currentColor",
  ...n
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: t,
    height: r,
    viewBox: s,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M4.16667 5.83329C4.16667 5.14293 4.72631 4.58329 5.41667 4.58329C6.10702 4.58329 6.66667 5.14293 6.66667 5.83329C6.66667 6.52365 6.10702 7.08329 5.41667 7.08329C4.72631 7.08329 4.16667 6.52365 4.16667 5.83329ZM5.41667 2.91663C3.80583 2.91663 2.5 4.22246 2.5 5.83329C2.5 7.44413 3.80583 8.74996 5.41667 8.74996C7.0275 8.74996 8.33333 7.44413 8.33333 5.83329C8.33333 4.22246 7.0275 2.91663 5.41667 2.91663ZM10 6.66663H16.6667V4.99996H10V6.66663ZM13.3333 14.1666C13.3333 13.4763 13.893 12.9166 14.5833 12.9166C15.2737 12.9166 15.8333 13.4763 15.8333 14.1666C15.8333 14.857 15.2737 15.4166 14.5833 15.4166C13.893 15.4166 13.3333 14.857 13.3333 14.1666ZM14.5833 11.25C12.9725 11.25 11.6667 12.5558 11.6667 14.1666C11.6667 15.7775 12.9725 17.0833 14.5833 17.0833C16.1942 17.0833 17.5 15.7775 17.5 14.1666C17.5 12.5558 16.1942 11.25 14.5833 11.25ZM3.33333 13.3333V15H10V13.3333H3.33333Z",
        fill: o
      }
    )
  }
);
export {
  l as default
};
